import { apiClient } from '@app/lib'
import { useMutation, useQueryClient } from '@tanstack/react-query'

export const useChangeName = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationKey: ['changeName'],
    mutationFn: async (input: { firstName?: string; lastName?: string }) => {
      const { data } = await apiClient.post('/api/me', input)

      return data
    },
    onSuccess: (data) => queryClient.setQueryData(['me'], data.data)
  })
}
